module.exports = __webpack_public_path__ + "img/camera.bd9875b3.svg";